module.exports = __webpack_public_path__ + "assets/img/ljs2.ba4a62c0.png";